export default function formatDate(dateString) {
	const date = new Date(dateString);

	// eslint-disable-next-line
	if (isNaN(date)) {
		return dateString;
	}

	const year = date.getFullYear();
	const month = `0${date.getMonth() + 1}`;
	const day = `0${date.getDate()}`;
	const hours = `0${date.getHours()}`;
	const minutes = `0${date.getMinutes()}`;
	const seconds = `0${date.getSeconds()}`;

	return `${[year, month.slice(-2), day.slice(-2)].join('-')} ${[hours.slice(-2), minutes.slice(-2), seconds.slice(-2)].join(':')}`;
}
